















































































































































































import Confirmacao from '@/components/ui/Confirmacao.vue'
import { PreVendaListagem } from '@/models/pre-venda/PreVenda'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { ImportarPreVendaUseCase } from '@/usecases'
import { PreVendaUseCase } from '@/usecases/venda/PreVendaUseCase'
import { Component, Watch, Ref, Prop, PropSync } from 'vue-property-decorator'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import { Cliente, TabelaDePreco } from '@/models'
import Vue from "vue"
import VueQuagga from "vue-quaggajs"
Vue.use(VueQuagga);

@Component({
	components: {
		Confirmacao,
		SeletorDeCliente,
	},
})
export default class DialogoDeImportarPreVenda extends Vue {
	@PropSync('mostra', { type: Boolean, default: false }) syncMostra!: boolean
	@Prop({ type: Boolean }) telaDeEmissaoDeNota!: boolean
	@Ref() form!: HTMLFormElement
	@Ref("confirmacao") confirmacao!: Confirmacao
	@Prop({ type: Object }) tabelaDePrecoSelecionada!: TabelaDePreco | null

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	preVendas: PreVendaListagem[] = []
	loading = false
	identificador = ''
	importarPreVendaUseCase = new ImportarPreVendaUseCase()
	preVendaUseCase = new PreVendaUseCase()
	carregando = false
	filtro: FiltroDePreVenda = {
		cliente: null,
		identificador: '',
	}
	mostrarDialogoLeituraDeCodigoBarras = false
	showCamera = false
	buscandoIdentificador = false

	readerSize = {
		width: 860,
		height: 480,
	}

	get lojaId() {
		return this.telaDeEmissaoDeNota 
			? VendaModule.lojaDaEntrada?.id
			: VendaModule.lojaDaVenda?.id
	}

	@Watch('syncMostra', { immediate: true })
	async buscarPreVenda() {

		if(!this.syncMostra) return
		this.loading = true

		const params = {
			situacoes: 'Aberto',
			lojaId: this.lojaId,
			cpfOuCnpjCliente: this.filtro.cliente != null ? this.filtro.cliente.cnpjOuCpf : undefined,
			identificador: this.filtro.identificador != '' ? this.filtro.identificador : undefined,
		}

		try {
			const lista = await this.preVendaUseCase.findPreVendaListagem(params)
			const toTime = (d?: Date |string | null) => (d ? new Date(d).getTime() : 0);

			this.preVendas = lista.slice().sort((a, b) => toTime(b.dataHoraCriacao) - toTime(a.dataHoraCriacao));
			this.loading = false
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	fechar(){
		this.syncMostra = false
		this.filtro = {
			cliente: null,
			identificador: '',
		}
	}

	async importarPreVenda(PreVendaListagem: PreVendaListagem) {
		try {
			this.loading = true 
			const resultado = await this.importarPreVendaUseCase.importarPreVenda(PreVendaListagem.identificador, this.telaDeEmissaoDeNota, this.tabelaDePrecoSelecionada)
			
			this.$emit('preVendaImportada', resultado)
			this.fechar()
		} catch(e) {
			AlertModule.setError(e)
		} finally {
			this.loading = false
		}
	}

	limparFiltros() {
		this.filtro = {
			cliente: null,
			identificador: '',
		}

		this.buscarPreVenda()
	}

	abrirLeitorDeCodigoDeBarras() {
		this.mostrarDialogoLeituraDeCodigoBarras = true
		this.showCamera = true
	}

	fecharLeitorDeCodigoDeBarras() {
		this.mostrarDialogoLeituraDeCodigoBarras = false
		this.showCamera = false
		this.buscandoIdentificador = false
	}

	async onBarcodeDetected(data: any) {
		this.showCamera = false
		this.buscandoIdentificador = true

		try {
			const codigoLido = data?.codeResult?.code

			if (!codigoLido) {
				throw new Error('Não foi possível ler o código de barras')
			}

			this.filtro.identificador = codigoLido

			await this.buscarPreVenda()

		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.buscandoIdentificador = false
			this.mostrarDialogoLeituraDeCodigoBarras = false
			this.showCamera = true
		}
	}
}

export interface FiltroDePreVenda {
	cliente: Cliente | null
	identificador: string | null
}

